import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Statement.RequestPaymentUrl.IRequest;
type Response = Api.Core.Statement.RequestPaymentUrl.IResponse;
type Headers = Api.Core.Statement.RequestPaymentUrl.IHeaders;
const url = '/api/DealerManagement/Statement/GeneratePaymentLink';
export default async function statmentRequestPaymentUrlApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    headers: getDefaultHeaders(),
    body,
  });
  return serverResponse;
}
